import React from 'react';
const Cessione_di_azienda = () => {
    return (
        <>            
            <table cellpadding="3" cellspacing="0">
                <tbody>
                    <tr>
                        <td colspan="3" valign="top">
                        <h4 id="3"><strong>Documenti Cessione d'azienda in atto di persone fisiche</strong></h4>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Carta d’identità o patente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Tesserino del codice fiscale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Estratto per riassunto dell’atto di nascita</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Certificato di stato libero o di vedovanza</td>
                        <td valign="top">Per celibi, nubili, vedovi, divorziati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Estratto per riassunto dell’atto di matrimonio</td>
                        <td valign="top">Per coniugati, anche se separati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Sentenza/decreto di separazione o di divorzio</td>
                        <td valign="top">Per separati e divorziati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">- Copia dell’atto di separazione dei beni
                        - Copia dell’atto di fondo patrimoniale</td>
                        <td valign="top">Per coniugati</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Autorizzazione giudiziale</td>
                        <td valign="top">Per rappresentanza di incapaci</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Permesso di soggiorno</td>
                        <td valign="top">Per extracomunitari</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h4 id="4"><strong>Intervento in atto di enti e società</strong></h4>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">documento d’identità del legale rappresentante</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">certificato camerale</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">statuto vigente</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">libro verbali con delibera firmata</td>
                        <td valign="top">Per enti con consiglio di amministrazione</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">copia autentica della procura</td>
                        <td valign="top">Per intervento di procuratore</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h4 id="5"><strong>Cessione d'azienda documenti inerenti l'oggetto della cessione</strong></h4>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Rogito o sentenza</td>
                        <td valign="top">Titolo di acquisto dell’azienda</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Copia del contratto</td>
                        <td valign="top">Se c’è contratto preliminare</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Elenco cespiti ammortizzabili con relativa valorizzazione e quote di ammortamento</td>
                        <td valign="top">Se ci sono beni strumentali</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Elenco delle rimanenze con indicazione della relativa valorizzazione e del metodo di valutazione utilizzato</td>
                        <td valign="top">Se ci sono beni merce</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Elenco dettagliato, con valorizzazione e con copia dei titoli abilitativi all’utilizzo</td>
                        <td valign="top">Se ci sono beni immateriali in proprietà o in licenza</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Elenco dettagliato, con valorizzazione, scadenze e garanzie di solvibilità</td>
                        <td valign="top">Se ci sono crediti</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Elenco dettagliato</td>
                        <td valign="top">Se ci sono contratti</td>
                    </tr>
                    <tr>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                        <td valign="top">&nbsp;</td>
                    </tr>
                    <tr>
                        <td colspan="3" valign="top">
                        <h4 id="6"><strong>Cessione d'azienda se l'azienda comprende beni immobili</strong></h4>
                        </td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">Rogito o sentenza</td>
                        <td valign="top">Titolo di acquisto</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">- Certificato catastale e planimetria con confini
                        -Abilitazioni edilizie comunali rilasciate dal 1967 in avanti (licenze, concessioni, autorizzazioni, d.i.a.,permessi di costruire, pratiche di condono, licenze di abitabilità)
                        - Referto tecnico</td>
                        <td valign="top">Se si tratta di unità immobiliare</td>
                    </tr>
                    <tr className='stacK'>
                        <td valign="top"><img alt="notaio treviso - check" hspace="3" style={{width:'15px'}} src='https://www.notaio-treviso.com/notaio_treviso_check.webp'/></td>
                        <td valign="top">- Certificato catastale e planimetria con confini
                        - Certificato di destinazione urbanistica</td>
                        <td valign="top">Se si tratta di terreno</td>
                    </tr>
                </tbody>
            </table>
        </>
        );
    }

export default Cessione_di_azienda;